module.exports = __webpack_public_path__ + "assets/img/bind10.1327b00d.png";